import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  lieRoot: {},
  lieWrapper: {},

  lieTitle: {},
  lieValue: {}
}));
